import Icon from 'veui/components/Icon'
import { IconBell } from 'dls-icons-vue'

Icon.register('bell', IconBell)
